import styled from 'styled-components';
import React from 'react';
import SVGIcons from './SVGIcons'
import Link from 'next/link';

const StyledImage = styled.div`
  position: absolute;
  top: 0;  
  left: 181px;

  @media only screen and (max-width: 1400px) {
    left: 10px;
  }

  @media only screen and (max-width: 600px) {
    top: 30px;  
    width: 125px;
    height: 41px;
  }

  @media only screen and (min-width: 601px) {
    width: 290px;
    height: 90px;
  }
`;

const Logo: React.FC = () => {
  return (
    <StyledImage>
      <Link aria-label={"page home - webproject"} href={"https://www.webproject.com.br"} passHref>
        <SVGIcons
          type='LOGO'
          width="100%"
          height="100%"
        />
      </Link>
    </StyledImage>
  );
};

export default Logo;